module.exports = __webpack_public_path__ + "static/media/400043_01.cd713617.png";